import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/vip',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-index" */ '~/pages/vip/pages/index'
        )
    ),
  },
  {
    path: '/vip/rule',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-vip-rule" */ '~/pages/vip/pages/rule')
    ),
  },
  {
    path: '/vip/privilege',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-privilege" */ '~/pages/vip/pages/privilege'
        )
    ),
  },
  {
    path: '/vip/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-record" */ '~/pages/vip/pages/record'
        )
    ),
  },
  {
    path: '/vip/mission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-mission" */ '~/pages/vip/pages/mission'
        )
    ),
  },
  {
    path: '/vip/honor',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-honor" */ '~/pages/vip/pages/honor'
        )
    ),
  },
  {
    path: '/vip/benefit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-benefit" */ '~/pages/vip/pages/benefit'
        )
    ),
  },
  {
    path: '/vip/activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-activity" */ '~/pages/vip/pages/activity'
        )
    ),
  },
  {
    path: '/vip/id',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-vip-id" */ '~/pages/vip/pages/id')
    ),
  },
  {
    path: '/vip/id/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-id-record" */ '~/pages/vip/pages/id/record'
        )
    ),
  },
  {
    path: '/vip/id/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-id-rule" */ '~/pages/vip/pages/id/rule'
        )
    ),
  },
  {
    path: '/vip/recall/levelRestore',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-recall-levelRestore" */ '~/pages/vip/pages/recall/levelRestore'
        )
    ),
  },
  {
    path: '/vip/recall/mission',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-recall-mission" */ '~/pages/vip/pages/recall/mission'
        )
    ),
  },
  {
    path: '/vip/recall/score',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-recall-mission" */ '~/pages/vip/pages/recall/score'
        )
    ),
  },
  {
    path: '/vip/mib/buy', // 神秘人
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-mib-buy" */ '~/pages/vip/pages/mib/buy'
        )
    ),
  },
  {
    path: '/vip/mib/record', // 神秘人购买记录
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-mib-record" */ '~/pages/vip/pages/mib/record'
        )
    ),
  },
  {
    path: '/vip/interests', // 权益对比页面
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-interests" */ '~/pages/vip/pages/interests'
        )
    ),
  },
  {
    path: '/vip/bounsPlay', // 玩法加成
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-bounsPlay" */ '~/pages/vip/pages/bounsPlay'
        )
    ),
  },

  {
    path: '/vip/member-care',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-vip-cs" */ '~/pages/vip/pages/vip-cs'
        )
    ),
  },
  {
    // saada vip 的半屏冲击礼包
    path: '/vip/halfScreenGift',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-halfScreenGift" */ '~/pages/vip/pages/halfScreenGift'
        )
    ),
  },
  {
    path: '/vip/halfScreenGift/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-vip-halfScreenGift-record" */ '~/pages/vip/pages/halfScreenGift/record'
        )
    ),
  },
] as RouteConfig[]
